import { useEffect, useState } from "react";
import "./setting_all.css";
import { SettingsSection } from "./SettingsSection";

export function Setting_all() {
  const [settings, setSettings] = useState({});
  const [saveStatus, setSaveStatus] = useState(null);
  const REACT_APP_API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";

  useEffect(() => {
    const getSettings = async () => {
      try {
        const res = await fetch(`${REACT_APP_API_URL}/settings`);

        const data = await res.json();

        setSettings(data);

        console.log("setting_return", data);
      } catch (error) {
        console.error("Failed to fetch settings:", error);
      }
    };

    getSettings();
  }, []);

  useEffect(() => {
    if (saveStatus?.status === "success") {
      const timer = setTimeout(() => {
        setSaveStatus(null);
      }, 3000); // 30 seconds

      return () => clearTimeout(timer);
    }
  }, [saveStatus]);

  // Save settings JSON to backend
  const saveSettingsToBackend = async (updatedSettings) => {
    try {
      const res = await fetch(`${REACT_APP_API_URL}/settings/update`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(updatedSettings),
      });

      const result = await res.json();

      console.log("Backend response:", result);
      setSaveStatus({
        status: result.status,
        message: result.message,
      });
    } catch (error) {
      console.error("Saving settings failed:", error);
    }
  };

  // update single value
  const updateSetting = (section, key, newValue, newUnit = null) => {
    setSettings((prev) => ({
      ...prev,

      [section]: {
        ...prev[section],

        [key]: {
          ...prev[section][key],

          value: newValue,

          ...(newUnit !== null && {
            unit: newUnit,
          }),
        },
      },
    }));
  };
  // Reset one setting
  const resetSetting = (section, key) => {
    const answer = window.confirm(`Reset ${key} back to default?`);

    if (!answer) {
      return;
    }

    setSettings((prev) => {
      const updated = {
        ...prev,

        [section]: {
          ...prev[section],

          [key]: {
            ...prev[section][key],

            value: prev[section][key].default,
          },
        },
      };

      // save immediately
      saveSettingsToBackend(updated);

      return updated;
    });
  };

  // Reset everything
  const resetAllSettings = () => {
    const answer = window.confirm(
      "Reset ALL settings back to their default values?"
    );

    if (!answer) {
      return;
    }

    setSettings((prev) => {
      const updated = {};

      Object.entries(prev).forEach(([section, values]) => {
        updated[section] = {};

        Object.entries(values).forEach(([key, option]) => {
          updated[section][key] = {
            ...option,

            value: option.default,
          };
        });
      });

      // save immediately
      saveSettingsToBackend(updated);

      return updated;
    });
  };

  // Manual save button
  const saveSettings = () => {
    saveSettingsToBackend(settings);
  };

  return (
    <div className="settings-page">
      <div className="settings-header">
        <h1>Application Settings</h1>

        <p>Double click Current Value to edit</p>

        <button className="save-btn" onClick={saveSettings}>
          Save Changes
        </button>
        {saveStatus && (
          <div className={`save-message ${saveStatus.status}`}>
            {saveStatus.message}
          </div>
        )}

        <button className="reset-all-btn" onClick={resetAllSettings}>
          Reset All
        </button>
      </div>

      {Object.entries(settings).map(([sectionName, values]) => (
        <SettingsSection
          key={sectionName}
          title={sectionName}
          data={values}
          updateSetting={updateSetting}
          resetSetting={resetSetting}
        />
      ))}
    </div>
  );
}
